// extracted by mini-css-extract-plugin
export default {"checkIcon":"checkIcon__ohtMNQ","closeIcon":"closeIcon__mpMg2E","opacity":"opacity__HVvOq4"};